export const CONFIG_SMS = 'autentica-ui-config-sms';
